import { memo } from 'react';

import dynamic from 'next/dynamic';

import { Builder } from '@builder.io/react';
import { uiImages } from '@/react/components/content/registry/data';
import buttonStyling from '../../content/registry/data/parts/buttonStyling';

/**
 * Register the Button component.
 */
const register = (): void => {
  Builder.registerComponent(memo(dynamic(async () => import('./index'))), {
    name: 'Button',
    inputs: [
      {
        friendlyName: 'Text',
        name: 'children',
        type: 'text',
        defaultValue: 'Shop Now'
      },
      {
        name: 'fullWidth',
        friendlyName: 'Full Width',
        type: 'boolean',
        defaultValue: false
      },
      {
        name: 'title',
        friendlyName: 'Title',
        type: 'string',
        defaultValue: ''
      },
      {
        name: 'ariaLabel',
        friendlyName: 'Aria Label',
        type: 'string',
        defaultValue: ''
      },
      buttonStyling
    ],
    image: uiImages.cubeImage
  });
};

export default register;
